<template>
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-[#FFA500] tw-bg-[#FFF6E5] tw-py-5 tw-px-4 tw-box-border"
  >
    <slot name="content"></slot>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped></style>
